const SELECTORS = {
  root: '[data-product-overview-specs-split]',
  button: '[data-overview-specs-button]',
  panel: '[data-overview-specs-panel]',
};

const BREAKPOINT_QUERY = '(min-width: 990px)';

function isDesktopLayout() {
  return window.matchMedia(BREAKPOINT_QUERY).matches;
}

function setActiveSection(root, sectionId) {
  const buttons = Array.from(root.querySelectorAll(SELECTORS.button));
  const panels = Array.from(root.querySelectorAll(SELECTORS.panel));

  buttons.forEach((btn) => {
    const isActive = sectionId != null && btn.getAttribute('data-overview-specs-button') === sectionId;
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  });

  panels.forEach((panel) => {
    const isActive = sectionId != null && panel.getAttribute('data-overview-specs-panel') === sectionId;
    panel.hidden = !isActive;
  });
}

function closeAllSections(root) {
  setActiveSection(root, null);
}

function showAllPanels(root) {
  root.querySelectorAll(SELECTORS.panel).forEach((panel) => {
    panel.hidden = false;
  });
  root.querySelectorAll(SELECTORS.button).forEach((btn) => {
    btn.classList.remove('is-active');
    btn.setAttribute('aria-expanded', 'false');
  });
}

function applyLayout(root) {
  const desktop = isDesktopLayout();
  root.dataset.overviewSpecsLayout = desktop ? 'columns' : 'accordion';

  if (desktop) {
    showAllPanels(root);
    return;
  }

  const buttons = Array.from(root.querySelectorAll(SELECTORS.button));
  if (buttons.length === 0) return;

  const activeBtn =
    buttons.find((b) => b.classList.contains('is-active')) ??
    buttons.find((b) => b.getAttribute('data-default-section') === 'true') ??
    buttons[0];

  setActiveSection(root, activeBtn.getAttribute('data-overview-specs-button'));
}

function initOverviewSpecsSplit(root) {
  const buttons = Array.from(root.querySelectorAll(SELECTORS.button));
  if (buttons.length === 0) return;

  applyLayout(root);

  if (root.dataset.overviewSpecsHandlersAttached === 'true') return;
  root.dataset.overviewSpecsHandlersAttached = 'true';

  root.addEventListener('click', (e) => {
    if (isDesktopLayout()) return;

    const btn = e.target?.closest?.(SELECTORS.button);
    if (!btn || !root.contains(btn)) return;

    if (btn.classList.contains('is-active')) {
      closeAllSections(root);
      return;
    }

    setActiveSection(root, btn.getAttribute('data-overview-specs-button'));
  });
}

function initAll(container = document) {
  container.querySelectorAll(SELECTORS.root).forEach(initOverviewSpecsSplit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll());
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (e) => initAll(e.target));
document.addEventListener('shopify:block:select', (e) => initAll(e.target));
document.addEventListener('shopify:block:deselect', (e) => initAll(e.target));

window.addEventListener('resize', () => {
  document.querySelectorAll(SELECTORS.root).forEach((root) => {
    applyLayout(root);
  });
});
